/**
 * Navigate to a custom protocol URL (e.g., xplor://, mailto:, tel:, etc.)
 *
 * This utility is necessary because React Router's navigate() function treats
 * custom protocol URLs as relative paths and appends them to the current URL.
 * Using window.location.href ensures proper handling of custom protocols.
 *
 * @param url - The custom protocol URL to navigate to (e.g., 'xplor://moments/view/123')
 *
 * @example
 * navigateToCustomProtocol('xplor://posts/view/456')
 * navigateToCustomProtocol(`xplor://moments/view/${momentId}`)
 */
export const navigateToCustomProtocol = (url: string): void => {
  window.location.href = url
}
